import { ROLE_SUPERADMIN } from '../../constants/roles';
import { createHasSessionAccessSelector } from '../session';

export const selectCanAccessPartnerManagement = createHasSessionAccessSelector([ROLE_SUPERADMIN]);